import { render, staticRenderFns } from "./feedItem.vue?vue&type=template&id=218f10d0&scoped=true&"
import script from "./feedItem.vue?vue&type=script&lang=js&"
export * from "./feedItem.vue?vue&type=script&lang=js&"
import style0 from "./feedItem.vue?vue&type=style&index=0&id=218f10d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218f10d0",
  null
  
)

export default component.exports